import request from './../request'

export const checkEmail = (data = {}) => request.post('auth/session/check-email', data).then((res) => res)

export const signIn = (data = {}) => request.post('auth/session', data).then((res) => res)

export const signInSSO = (ssoId, data = {}) =>
  request.post(`auth/session/sso/callback/${ssoId}`, data).then((res) => res)

export const signInSSOPKCE = (data = {}) => request.post('auth/session/sso-pkce', data).then((res) => res)

export const signInImpersonate = (userId) =>
  request.post(`auth/session/impersonate/${userId}`).then((res) => res)

export const signOut = (data = {}) => request.delete('auth/session', data).then((res) => res)

export const resetPassword = (data = {}) => request.post('auth/password-reset', data).then((res) => res)

export const resendPassword = (data = {}) => request.post('auth/password-reset', data).then((res) => res)

export const updatePassword = (resetToken = '', data = {}) =>
  request.post(`auth/password/${resetToken}`, data).then((res) => res)

export const getAccessToken = (resetToken = '', params) =>
  request.get(`auth/password-reset/${resetToken}`, { params }).then((res) => res)

export const updatePasswordProfile = (data = {}) =>
  request.put(`auth/profile/password`, data).then((res) => res)

export const getProfile = () => request.get('auth/profile').then((res) => res)
